import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit,
  faTrash,
  faUpload,
  faEye,
} from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import {
  updateNewHprUsersRepDetailsByTypeForPlant,
  getHprDetailsByrepId,
  handleNewHprRepApprovalpreparedByPlantIC,
  handleNewHprRepRejectionpreparedByPlantIC,
  getSignatureData,
  deleteSignatureById,
  postSignatureDataInPlantSide,
  uploadMultipleAgreementDocuments,
} from '../../store/modules/newUser/actions';
import {
  selectIsLoading,
  selectSingleUserData,
  selectIsLoadingApprovalPlant,
  selectIsLoadingRejectionPlant,
  selectSignatureArray,
  selectIpAddress,
} from '../../store/modules/newUser/selectors';
import EditBankDetailsModal from '../../components/EditBankDetailsModal';
import DigitalSignatureModal from '../../components/DigitalSingatureModal';
import SignaturesModal from '../../components/SignaturesModal';
import LoadingModal from '../../components/LoadingModal';
import ModalForImageZoom from '../../components/ModalForImageZoom';
import './PendingHPRregistrationPlantSideViewbyId.scss';
import EditHprModal from '../../components/EditHprModal';
import EditHprLocationModal from '../../components/EditHprLocationModal';

const ViewRegistaration = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => selectSingleUserData(state));
  console.log('hprData', data);
  const isLoading = useSelector((state) => selectIsLoading(state));
  const isLoadingFinish = useSelector((state) => selectIsLoadingApprovalPlant(state));
  const isLoadingReject = useSelector((state) => selectIsLoadingRejectionPlant(state));
  const ipAddress = useSelector((state) => selectIpAddress(state));
  const signatureArray = useSelector((state) => selectSignatureArray(state));
  const { id } = useParams();
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const [showEditLocationModal, setShowEditLocationModal] = useState(false);
  const [showBankDetailsModal, setshowBankDetailsModal] = useState(false);
  const [showDigitalSignatureModal, setshowDigitalSignatureModal] = useState(false);
  const [showSignatureModal, setshowSignatureModal] = useState(false);
  const [maskAadhar, setmaskAadhar] = useState(false);
  const [showImageModal, setshowImageModal] = useState(false);
  const [selectedImageValues, setselectedImageValues] = useState(null);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [documentPreviews, setDocumentPreviews] = useState([]);
  const fileInputRef = useRef(null);
  const checkIfDataIsNotNull = data?.village && data?.pincode && data?.mandal;
  const [storeValuesForLocation, setStoreValuesForLocation] = useState({
    village: null,
    pincode: null,
    mandal: null,
    district: null,
    state: null,
  });
  const [ip, setIp] = useState('IP Address not available');

  useEffect(() => {
    if (checkIfDataIsNotNull) {
      setStoreValuesForLocation(data);
    }
  }, [data, checkIfDataIsNotNull]);

  useEffect(() => {
    if (data?.agreementUpload) {
      const documents = data.agreementUpload;
      setDocumentPreviews(documents);
    } else {
      setDocumentPreviews([]);
    }
  }, [data]);

  useEffect(() => {
    const dataTobeSent = {
      id,
      type: 'plant',
    };
    dispatch(getHprDetailsByrepId(dataTobeSent));
  }, [dispatch, id]);

  const handleOnImagepressed = (img) => {
    setshowImageModal(!showImageModal);
    setselectedImageValues(img);
  };

  const handleIpAddress = () => {
    ipAddress?.then((res) => {
      setIp(res ? res?.ip : 'IP Not fetched');
    });
  };

  useEffect(() => {
    handleIpAddress();
  }, []);

  const handleOnSignatureArrayDataCalled = () => {
    setshowSignatureModal(!showSignatureModal);
    const values = {
      type: 'plant',
    };
    dispatch(getSignatureData(values));
  };

  const handleOnDigitalSignatureModalCalled = () => {
    setshowDigitalSignatureModal(!showDigitalSignatureModal);
  };

  const handleOnValueSelectedFromSignatureModal = (val) => {
    const approvedData = {
      id,
      status: 'approved',
      ipAddress: ip,
      signatureUrl: val?.signatureUrl,
    };
    dispatch(handleNewHprRepApprovalpreparedByPlantIC(approvedData));
  };

  const handleOnDeleteSignatureCalled = (value) => {
    const valuesToBepassed = {
      id: value?.id,
      type: 'plant',
    };
    dispatch(deleteSignatureById(valuesToBepassed));
  };

  const handleOnSignatureFetchedFromCanvasModal = (val) => {
    const values = {
      signature: val,
    };
    if (val !== null) {
      dispatch(postSignatureDataInPlantSide(values));
      handleOnSignatureArrayDataCalled();
    }
  };

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      const newDocuments = files.map((file) => ({
        file,
        url: URL.createObjectURL(file), // Temporary blob URL for preview
        name: file.name,
        isUploaded: false, // Flag to track if uploaded to S3
      }));
      setUploadedDocuments((prev) => [...prev, ...newDocuments]);
      toast.success(`${files.length} file(s) selected`);
    }
  };

  const submitDocuments = async () => {
    // console.log('uploadedDocuments', uploadedDocuments);
    if (uploadedDocuments.length === 0 && documentPreviews.length === 0) {
      toast.warning('Please upload at least one document');
      return;
    }

    try {
      toast.info('Uploading documents to S3...');

      // Create FormData with all files
      const formData = new FormData();
      uploadedDocuments.forEach((doc) => {
        formData.append('files', doc.file); // Append all files with same key 'files'
      });
      formData.append('id', id);
      formData.append('type', 'agreement');

      // Single API call to upload all files
      // console.log('formData', formData);
      const response = await dispatch(uploadMultipleAgreementDocuments(formData, 'plant'));
      // const newS3Urls = response.s3Urls; // Array of S3 URLs from backend
      console.log('response', response);
      // Combine existing S3 URLs with new ones
      // const allUrls = [...documentPreviews, ...newS3Urls]
      //   .filter((url) => url)
      //   .join(',');
      // setDocumentPreviews(allUrls);
      // Save to database
      // const updateData = {
      //   id,
      //   agreementUpload: allUrls,
      //   status: 'pending',
      // };

      // await dispatch(updateNewHprUsersRepDetailsByTypeForPlant(updateData));
      // toast.success('Documents uploaded and saved successfully');

      // Refresh data
      // const dataTobeSent = {
      //   id,
      //   type: 'plant',
      // };
      // dispatch(getHprDetailsByrepId(dataTobeSent));
      // // Clear state
      // setUploadedDocuments([]);
    } catch (error) {
      toast.error('Failed to upload documents');
      console.error(error);
    }
  };

  const handleRemoveDocument = async (index) => {
    // const docToRemove = uploadedDocuments[index];

    try {
      // Optional: Call API to delete from S3
      // await dispatch(deleteAgreementDocument(docToRemove.s3Url));

      const newDocuments = uploadedDocuments.filter((doc, i) => i !== index);
      setUploadedDocuments(newDocuments);
      toast.info('Document removed');
    } catch (error) {
      toast.error('Failed to remove document');
    }
  };

  const handlePreviewDocument = (url) => {
    window.open(url, '_blank');
  };

  const reject = () => {
    Swal.fire({
      title: 'Enter your reason for rejection',
      input: 'textarea',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Proceed',
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value) {
          const rejectData = {};
          rejectData.id = id;
          rejectData.status = 'rejected';
          rejectData.comment = result?.value;
          dispatch(handleNewHprRepRejectionpreparedByPlantIC(rejectData));
        }
        Swal.fire({
          title: 'Update!',
          text: 'You have successfully rejected',
          icon: 'success',
          timer: 2000,
        });
      }
    });
  };

  const approve = () => {
    if (
      storeValuesForLocation.village !== null
      && storeValuesForLocation.mandal !== null
      && storeValuesForLocation?.pincode !== null
    ) {
      handleOnSignatureArrayDataCalled();
    } else {
      Swal.fire('Alert', 'Please fill all the details', 'warning');
    }
  };

  const toggleEditUserModal = () => {
    setShowEditUserModal(!showEditUserModal);
  };

  const toggleEditLocationModal = () => {
    setShowEditLocationModal(!showEditLocationModal);
  };

  const toggleBankDetailsModal = () => {
    setshowBankDetailsModal(!showBankDetailsModal);
  };

  const submitUser = (values) => {
    const userDetailsThatNeedToBeUpdated = {
      hprOrDfName: values?.hprOrDfName,
      gender: values?.gender,
      age: values?.age,
      aadhaarNumber: values?.aadhaarNumber,
      mobileNumber: values?.mobileNumber,
      id,
      status: 'pending',
    };
    dispatch(
      updateNewHprUsersRepDetailsByTypeForPlant(userDetailsThatNeedToBeUpdated),
    );
  };

  const submitLocation = (values) => {
    const repUpdateData = {
      village: values?.village ? values?.village : null,
      mandal: values?.mandal ? values?.mandal : null,
      district: values?.district ? values?.district : null,
      state: values?.state ? values?.state : null,
      pincode: values?.pincode ? values?.pincode : null,
      geoTag: values?.geoTag ? values?.geoTag : null,
      id,
      status: 'pending',
    };
    dispatch(updateNewHprUsersRepDetailsByTypeForPlant(repUpdateData));
  };

  const submitBankDetails = (values) => {
    const repUpdateData = {
      bankName: values?.bankName,
      branchName: values?.branchName,
      ifscCode: values?.ifscCode,
      bankAccountNumber: values?.bankAccountNumber,
      branchCode: values?.branchCode,
      nameAsPerBankPassBook: values?.nameAsPerBankPassBook,
      id,
      status: 'pending',
    };
    dispatch(updateNewHprUsersRepDetailsByTypeForPlant(repUpdateData));
  };

  const aadharNumberTobeShown = data?.aadhaarNumber?.replace(
    /\d(?=\d{4})/g,
    '*',
  );

  const toggleMaskingOfAadar = () => {
    setmaskAadhar(!maskAadhar);
  };

  return (
    <>
      {!isLoading && data ? (
        <div className="view-registration">
          {data?.approvedByPlantIc === 'pending' ? (
            <div className="row center">
              <div className="col-12 col-md-12">
                <div className="buttons">
                  <button
                    type="button"
                    className="button danger"
                    onClick={reject}
                  >
                    Reject
                  </button>
                  <button
                    type="button"
                    className="button primary"
                    onClick={approve}
                  >
                    Approve
                  </button>
                </div>
              </div>
            </div>
          ) : null}

          <div className="row center">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="status-card">
                <div className="left">
                  1. Approved By Plant IC:
                  {data.approvedByPlantIc}
                </div>
                <div className="right">
                  2. Status at RH P&I:
                  {data.approvedByRHPI}
                </div>
                <div className="left">
                  3. Status at RI F&A:
                  {data?.approvedByRIFA}
                </div>
                <div className="right">
                  4. Status at EA P&I:
                  {data?.approvedByEAPI}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 d-flex-col">
              <div className="item">
                {/* <h4 className="title">
                  User details
                  {data?.approvedByPlantIc === 'pending' && (
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="edit-icon"
                      onClick={toggleEditUserModal}
                    />
                  )}
                </h4> */}
                <div className="content">
                  <div className="row">
                    <div className="col-12">
                      <div className="row">
                        <div className="col-12 col-lg-6 d-flex-col">
                          <div className="row right">
                            {data?.aadhaarUpload && (
                              <div className="col-12 col-md-6">
                                <div className="item p-left">
                                  <h4 className="title">Aadhar Card Image</h4>
                                  <div
                                    role="button"
                                    tabIndex={0}
                                    className="picture"
                                    onClick={() => handleOnImagepressed({
                                      type: 'Aadhar Card',
                                      link: `${data?.aadhaarUpload}?${new Date().getTime()}`,
                                      farmerName: data?.hprOrDfName,
                                    })}
                                  >
                                    <img
                                      src={`${data.aadhaarUpload}?${new Date().getTime()}`}
                                      alt="Aadhar Card"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                            {data?.bankPassBookUpload && (
                              <div className="col-12 col-md-6">
                                <div className="item p-right">
                                  <h4 className="title">Bank Passbook Image</h4>
                                  <div
                                    role="button"
                                    tabIndex={0}
                                    className="picture"
                                    onClick={() => handleOnImagepressed({
                                      type: 'Bank Passbook',
                                      link: `${data?.bankPassBookUpload}?${new Date().getTime()}`,
                                      farmerName: data?.hprOrDfName,
                                    })}
                                  >
                                    <img
                                      src={`${data.bankPassBookUpload}?${new Date().getTime()}`}
                                      alt="Bank Passbook"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 d-flex-col">
                          <div className="row between">
                            <div className="col-3">
                              <div className="content__title">Name</div>
                            </div>
                            <div className="col-8">
                              <div className="content__text">
                                {data.hprOrDfName}
                              </div>
                            </div>
                          </div>
                          <div className="row between">
                            <div className="col-3">
                              <div className="content__title">MCC Name</div>
                            </div>
                            <div className="col-8">
                              <div className="content__text">
                                {data?.mccName || 'N/A'}
                              </div>
                            </div>
                          </div>
                          <div className="row between">
                            <div className="col-3">
                              <div className="content__title">Mobile Number</div>
                            </div>
                            <div className="col-8">
                              <div className="content__text">
                                {data?.mobileNumber || 'N/A'}
                              </div>
                            </div>
                          </div>
                          <div className="row between">
                            <div className="col-3">
                              <div className="content__title">Gender</div>
                            </div>
                            <div className="col-8">
                              <div className="content__text">
                                {data?.gender || 'N/A'}
                              </div>
                            </div>
                          </div>
                          <div className="row between">
                            <div className="col-3">
                              <div className="content__title">Date of Birth</div>
                            </div>
                            <div className="col-8">
                              <div className="content__text">
                                {moment(data?.age).format('DD/MM/YYYY')}
                              </div>
                            </div>
                          </div>
                          <div className="row between">
                            <div className="col-3">
                              <div className="content__title">Aadhar Number</div>
                            </div>
                            <div
                              role="button"
                              tabIndex={0}
                              className="col-8"
                              onClick={() => toggleMaskingOfAadar()}
                            >
                              <div className="content__text">
                                {maskAadhar
                                  ? data?.aadhaarNumber
                                  : aadharNumberTobeShown}
                              </div>
                            </div>
                          </div>
                          <div className="row between">
                            <div className="col-3">
                              <div className="content__title">Plant Code</div>
                            </div>
                            <div className="col-8">
                              <div className="content__text">
                                {data?.plantCode || 'N/A'}
                              </div>
                            </div>
                          </div>
                          <div className="row between">
                            <div className="col-3">
                              <div className="content__title">Region</div>
                            </div>
                            <div className="col-8">
                              <div className="content__text">
                                {data?.regionName || 'N/A'}
                              </div>
                            </div>
                          </div>
                          <div className="row between">
                            <div className="col-3">
                              <div className="content__title">Type</div>
                            </div>
                            <div className="col-8">
                              <div className="content__text">
                                {data?.hprOrDf || 'N/A'}
                              </div>
                            </div>
                          </div>
                          <div className="row between">
                            <div className="col-3">
                              <div className="content__title">PAN Card</div>
                            </div>
                            <div className="col-8">
                              <div className="content__text">
                                {data?.panCard || 'N/A'}
                              </div>
                            </div>
                          </div>
                          <div className="row between">
                            <div className="col-3">
                              <div className="content__title">Aadhar-PAN Link Status</div>
                            </div>
                            <div className="col-8">
                              <div className="content__text">
                                {data?.aadhaarPancardLinkStatus || 'N/A'}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 d-flex">
                      <div className="row w-100 m-h-100">
                        <div className="col-12 col-md-6">
                          <div style={{ padding: '15px' }}>
                            <h4 className="title" style={{ marginBottom: '15px' }}>
                              Agreements Upload
                              {data?.approvedByPlantIc === 'pending' && (
                                <FontAwesomeIcon
                                  icon={faUpload}
                                  className="edit-icon"
                                  onClick={() => fileInputRef.current?.click()}
                                  style={{ cursor: 'pointer', marginLeft: '10px' }}
                                />
                              )}
                            </h4>
                            <input
                              ref={fileInputRef}
                              type="file"
                              multiple
                              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                              onChange={handleFileUpload}
                              style={{ display: 'none' }}
                            />
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                              {documentPreviews.length > 0 ? (
                                documentPreviews.map((doc, index) => (
                                  <div
                                    key={doc}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      padding: '10px',
                                      border: '1px solid #ddd',
                                      borderRadius: '5px',
                                      backgroundColor: '#f9f9f9',
                                    }}
                                  >
                                    <span style={{
                                      flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                    }}
                                    >
                                      Document
                                      {index + 1}
                                    </span>
                                    <FontAwesomeIcon
                                      icon={faEye}
                                      style={{ cursor: 'pointer', marginLeft: '10px', color: '#007bff' }}
                                      onClick={() => handlePreviewDocument(doc)}
                                    />
                                  </div>
                                ))
                              ) : null}
                              {uploadedDocuments.length > 0 ? (
                                uploadedDocuments.map((doc, index) => (
                                  <div
                                    key={`upload-${doc.name}`}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      padding: '10px',
                                      border: '1px solid #ddd',
                                      borderRadius: '5px',
                                      backgroundColor: '#f0f8ff',
                                    }}
                                  >
                                    <span style={{
                                      flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                    }}
                                    >
                                      {doc.name}
                                    </span>
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                      <FontAwesomeIcon
                                        icon={faEye}
                                        style={{ cursor: 'pointer', color: '#007bff' }}
                                        onClick={() => handlePreviewDocument(doc.url)}
                                      />
                                      {data?.approvedByPlantIc === 'pending' && (
                                        <FontAwesomeIcon
                                          icon={faTrash}
                                          style={{ cursor: 'pointer', color: '#dc3545' }}
                                          onClick={() => handleRemoveDocument(index)}
                                        />
                                      )}
                                    </div>
                                  </div>
                                ))
                              ) : null}
                              {documentPreviews.length === 0 && uploadedDocuments.length === 0 && (
                                <div style={{ padding: '20px', color: '#666' }}>
                                  No documents uploaded yet
                                  {data?.approvedByPlantIc === 'pending' && (
                                    <div style={{ marginTop: '10px' }}>
                                      <button
                                        type="button"
                                        onClick={() => fileInputRef.current?.click()}
                                        className="button primary"
                                      >
                                        <FontAwesomeIcon icon={faUpload} style={{ marginRight: '5px' }} />
                                        Upload Documents
                                      </button>
                                    </div>
                                  )}
                                </div>
                              )}
                              {data?.approvedByPlantIc === 'pending' && uploadedDocuments.length !== 0 && (
                                <div style={{ marginTop: '15px', textAlign: 'center' }}>
                                  <button
                                    type="button"
                                    onClick={submitDocuments}
                                    disabled={uploadedDocuments.length === 0
                                      && documentPreviews.length === 0}
                                    style={{
                                      padding: '10px 20px',
                                      backgroundColor: uploadedDocuments.length > 0 ? '#28a745' : '#6c757d',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '5px',
                                      cursor: uploadedDocuments.length > 0 ? 'pointer' : 'not-allowed',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    Submit Documents
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-6">
                          <div style={{ padding: '15px' }}>
                            {data?.approvedByPlantIc === 'pending' && (
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  className="edit-icon"
                                  onClick={toggleEditLocationModal}
                                />
                              </div>
                            )}
                            <h4 className="title" style={{ marginBottom: '15px' }}>Location Details</h4>
                            <div className="row between w-100">
                              <div className="col-3">
                                <div className="content__title">Village</div>
                              </div>
                              <div className="col-8">
                                <div className="content__text">
                                  {data?.village || 'N/A'}
                                </div>
                              </div>
                            </div>
                            <div className="row between w-100">
                              <div className="col-3">
                                <div className="content__title">Mandal</div>
                              </div>
                              <div className="col-8">
                                <div className="content__text">
                                  {data?.mandal || 'N/A'}
                                </div>
                              </div>
                            </div>
                            <div className="row between w-100">
                              <div className="col-3">
                                <div className="content__title">District</div>
                              </div>
                              <div className="col-8">
                                <div className="content__text">
                                  {data?.district || 'N/A'}
                                </div>
                              </div>
                            </div>
                            <div className="row between w-100">
                              <div className="col-3">
                                <div className="content__title">State</div>
                              </div>
                              <div className="col-8">
                                <div className="content__text">
                                  {data?.state || 'N/A'}
                                </div>
                              </div>
                            </div>
                            <div className="row between w-100">
                              <div className="col-3">
                                <div className="content__title">Pin Code</div>
                              </div>
                              <div className="col-8">
                                <div className="content__text">
                                  {data?.pincode || 'N/A'}
                                </div>
                              </div>
                            </div>
                            <div className="row between w-100">
                              <div className="col-3">
                                <div className="content__title">Geo Tag</div>
                              </div>
                              <div className="col-8">
                                <div className="content__text">
                                  {data?.geoTag || 'N/A'}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 d-flex-col">
              <div className="item">
                {/* <h4 className="title">
                  Bank details
                  {data?.approvedByPlantIc === 'pending' && (
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="edit-icon"
                      onClick={toggleBankDetailsModal}
                    />
                  )}
                </h4> */}
                <div className="content">
                  <div className="row">
                    <div className="col-12 col-md-6 d-flex-col">
                      <div className="row between">
                        <div className="col-5">
                          <div className="content__title">Bank Name</div>
                        </div>
                        <div className="col-6">
                          <div className="content__text">
                            {data?.bankName || 'N/A'}
                          </div>
                        </div>
                      </div>
                      <div className="row between">
                        <div className="col-5">
                          <div className="content__title">Branch Name</div>
                        </div>
                        <div className="col-6">
                          <div className="content__text">
                            {data?.branchName || 'N/A'}
                          </div>
                        </div>
                      </div>
                      <div className="row between">
                        <div className="col-5">
                          <div className="content__title">Branch Code</div>
                        </div>
                        <div className="col-6">
                          <div className="content__text">
                            {data?.branchCode || 'N/A'}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 d-flex-col">
                      <div className="row between">
                        <div className="col-7">
                          <div className="content__title">IFSC Code</div>
                        </div>
                        <div className="col-4">
                          <div className="content__text">
                            {data?.ifscCode || 'N/A'}
                          </div>
                        </div>
                      </div>
                      <div className="row between">
                        <div className="col-7">
                          <div className="content__title">Account Number</div>
                        </div>
                        <div className="col-4">
                          <div className="content__text">
                            {data?.bankAccountNumber || 'N/A'}
                          </div>
                        </div>
                      </div>
                      <div className="row between">
                        <div className="col-7">
                          <div className="content__title">Name as per Passbook</div>
                        </div>
                        <div className="col-4">
                          <div className="content__text">
                            {data?.nameAsPerBankPassBook || 'N/A'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 d-flex-col">
              <div className="item">
                <h4 className="title">Digital Signature</h4>
                <div className="content">
                  <div className="row">
                    <div className="col-12 col-md-6 d-flex-col">
                      <div className="col-1 col-md-6 d-flex-col justify-content-center">
                        {data?.plantIcSign ? (
                          <img
                            src={data?.plantIcSign}
                            alt="signature"
                            className="col-md-6 d-flex"
                          />
                        ) : (
                          <div className="content__text">N/A</div>
                        )}
                        <div className="content__mtitle">Plant Incharge</div>
                        {data?.plantIcSignDate ? (
                          <div className="content__miniTitle">
                            {`Signed on ${moment(data?.plantIcSignDate).format('DD MMM, YYYY, hh:mm:a')}`}
                          </div>
                        ) : (
                          <div className="content__miniTitle">Not yet signed</div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-md-6 d-flex-col">
                      <div className="col-1 col-md-6 d-flex-col justify-content-center">
                        {data?.rhpiSign ? (
                          <img
                            src={data?.rhpiSign}
                            alt="signature"
                            className="col-md-6 d-flex"
                          />
                        ) : (
                          <div className="content__text">N/A</div>
                        )}
                        <div className="content__mtitle">RH P&I</div>
                        {data?.rhpiSignDate ? (
                          <div className="content__miniTitle">
                            {`Signed on ${moment(data?.rhpiSignDate).format('DD MMM, YYYY, hh:mm:a')}`}
                          </div>
                        ) : (
                          <div className="content__miniTitle">Not yet signed</div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-md-6 d-flex-col">
                      <div className="col-1 col-md-6 d-flex-col justify-content-center">
                        {data?.rifaSign ? (
                          <img
                            src={data?.rifaSign}
                            alt="signature"
                            className="col-md-6 d-flex"
                          />
                        ) : (
                          <div className="content__text">N/A</div>
                        )}
                        <div className="content__mtitle">Regional Incharge F&A</div>
                        {data?.rifaSignDate ? (
                          <div className="content__miniTitle">
                            {`Signed on ${moment(data?.rifaSignDate).format('DD MMM, YYYY, hh:mm:a')}`}
                          </div>
                        ) : (
                          <div className="content__miniTitle">Not yet signed</div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-md-6 d-flex-col">
                      <div className="col-1 col-md-6 d-flex-col justify-content-center">
                        {data?.eapiSign ? (
                          <img
                            src={data?.eapiSign}
                            alt="signature"
                            className="col-md-6 d-flex"
                          />
                        ) : (
                          <div className="content__text">N/A</div>
                        )}
                        <div className="content__mtitle">EA P&I</div>
                        {data?.eapiSignDate ? (
                          <div className="content__miniTitle">
                            {`Signed on ${moment(data?.eapiSignDate).format('DD MMM, YYYY, hh:mm:a')}`}
                          </div>
                        ) : (
                          <div className="content__miniTitle">Not yet signed</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {showEditUserModal && (
        <EditHprModal
          show={showEditUserModal}
          toggle={toggleEditUserModal}
          onSubmit={submitUser}
          values={data}
        />
      )}
      {showEditLocationModal && (
        <EditHprLocationModal
          show={showEditLocationModal}
          toggle={toggleEditLocationModal}
          onSubmit={submitLocation}
          values={data}
        />
      )}
      {showBankDetailsModal && (
        <EditBankDetailsModal
          show={showBankDetailsModal}
          toggle={toggleBankDetailsModal}
          onSubmit={submitBankDetails}
          values={data}
        />
      )}
      {showImageModal && (
        <ModalForImageZoom
          show={showImageModal}
          toggle={handleOnImagepressed}
          imageUrl={selectedImageValues}
        />
      )}
      {showDigitalSignatureModal && (
        <DigitalSignatureModal
          show={showDigitalSignatureModal}
          toggle={handleOnDigitalSignatureModalCalled}
          onSubmit={handleOnSignatureFetchedFromCanvasModal}
        />
      )}
      {showSignatureModal && (
        <SignaturesModal
          signatures={signatureArray}
          show={showSignatureModal}
          isLoading={isLoading}
          onSubmit={handleOnValueSelectedFromSignatureModal}
          toggle={handleOnSignatureArrayDataCalled}
          onDelete={handleOnDeleteSignatureCalled}
          showSignatureCanvas={handleOnDigitalSignatureModalCalled}
        />
      )}
      <LoadingModal show={isLoading || isLoadingFinish || isLoadingReject} />
    </>
  );
};

export default ViewRegistaration;
